import Icon from '../components/Icon.vue'

Icon.register({
  'text-height': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M304 32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32h-56v304h40c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-160c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h40v-304h-56v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h288zM560 368c15.6 0 20.6 18 11.3 27.3l-80 80c-2.6 2.6-7.7 4.7-11.3 4.7s-8.7-2.1-11.3-4.7l-80-80c-10-10-3-27.3 11.3-27.3h48v-224h-48c-15.6 0-20.6-18-11.3-27.3l80-80c2.6-2.6 7.7-4.7 11.3-4.7s8.7 2.1 11.3 4.7l80 80c10 10 3 27.3-11.3 27.3h-48v224h48z'
      }
    ]
  }
})
